"use client";
import { useEffect, useRef } from "react";
import { motion, stagger, useAnimate } from "framer-motion";
import { cn } from "@/lib/utils";
import { useInView } from "framer-motion";

export const TextGenerateEffect = ({
  words,
  className,
}: {
  words: string;
  className?: string;
}) => {
  const [scope, animate] = useAnimate();
  let wordsArray = words.split(" ");
  const containerRef = useRef(null);
  const isInView = useInView(containerRef, { once: true }); // Set once to false to allow re-animation

  useEffect(() => {
    // Reset opacity when not in view
    if (!isInView) {
      animate("span", { opacity: 0 }, { duration: 0 });
    }
    // Animate when in view
    if (isInView) {
      animate(
        "span",
        { opacity: 1 },
        {
          duration: 1,
          delay: stagger(0.05),
        }
      );
    }
  }, [isInView, animate]);

  const renderWords = () => {
    return (
      <motion.div ref={scope}>
        {wordsArray.map((word, idx) => {
          return (
            <motion.span
              key={word + idx}
              className={` ${
                idx > 4 ? "text-green" : "dark:text-white text-black"
              } opacity-0`}
            >
              {word}{" "}
            </motion.span>
          );
        })}
      </motion.div>
    );
  };

  return (
    <div className={cn("font-bold", className)} ref={containerRef}>
      {/* mt-4 to my-4 */}
      <div className="my-4">
        {/* remove  text-2xl from the original */}
        <div className="text-justify dark:text-white text-black leading-snug  text-2xl  sm:text-3xl tracking-wide">
          {renderWords()}
        </div>
      </div>
    </div>
  );
};
